import React, { Fragment, useEffect, useRef, useState } from 'react'
import { UncontrolledTooltip, Collapse, Nav, Navbar, NavItem, NavLink, Button, UncontrolledCollapse } from 'reactstrap';
import { MdClose } from "react-icons/md";
import { useSelector, useDispatch } from 'react-redux';
import { setAgent } from "../../redux/actions/agentAction";
import { toggleSidebar } from "../../redux/actions/sidebarAction";
import trrWebLogo from '../../assets/trr-web-logo.png'
import '../../styles/components/sidebar.scss'
import { MdArrowDropDownCircle, MdKeyboardArrowDown, MdPersonAdd, MdWeb, MdAssignment, MdEmail, MdBook, MdHouse, MdDescription, MdLocationCity, MdAnnouncement, MdMail, MdLockOutline } from 'react-icons/md';
import { IoMdSettings } from 'react-icons/io';
import userbiz from '../../biz/userBiz'
import { FaFolder, FaReceipt } from "react-icons/fa";
import { HiShoppingCart } from "react-icons/hi";

const Sidebar = () => {
    const sidebarControl = useSelector(state => state.sidebar);
    // const loggedInAgent = useSelector(state => state.agent);
    const boxRef = useRef(null);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState({
        // isOpenMyFolder: true,
        // isOpenEmploymentApplication: true,
        // isOpenPurchaseForm: true,
        // isOpenRentForm: true,
        // isOpenOfficialReceipt: true,
        // isOpenTaxInvoice: true,
        // isOpenNextsixProperty: true,
        // isOpenMyStore: true,
    });

    let loggedInAgent = useSelector(state => state.agent)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                dispatch(toggleSidebar(false));
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
    }, [boxRef]);


    useEffect(() => {
        dispatch(toggleSidebar(false));
    }, [dispatch])

    // useEffect(() => {
    //     console.log("SIDE BAR ")
    //     console.log(loggedInAgent)
    // }, [])

    const handleCollapse = name => () => {
        setIsOpen(prevState => ({
            ...prevState,
            [name]: !prevState[name]
        }));
    };

    const logout = () => {
        dispatch(setAgent({}))
        window.location.href = "/"
    }

    const myFolderGroup = [
        {
            group: 'My Folder',
            stateName: 'isOpenMyFolder',
            GroupIcon: FaFolder,
            navItems: [
                { to: '/analytics', name: 'my PA', exact: false, Icon: MdWeb, id: 'My PA' },
                { to: '/myPV/myPVListing', name: 'my payment voucher', exact: false, Icon: MdWeb, id: 'My payment voucher' },
                { to: '/myUserProfile', name: 'my profile', exact: false, Icon: MdWeb, id: 'My profile' },
                { to: '/cp58/cp58Listing', name: 'my CP 58 listing', exact: false, Icon: MdWeb, id: 'My cp 58 listing' },
            ]
        }
    ]

    const employmentApplicationGroup = [
        {
            group: 'Employment Application',
            stateName: 'isOpenEmploymentApplication',
            GroupIcon: MdPersonAdd,
            navItems: [
                { to: '/employment/employmentListing', name: 'employment application', exact: false, Icon: MdWeb, id: 'Employment application' },
                { to: '/employment/employmentAttachmentListing', name: 'employment application attachment', exact: false, Icon: MdWeb, id: 'Employment application attachment' },
            ]
        }
    ]

    const purchaseFormGroup = [
        {
            group: 'Purchase Form',
            stateName: 'isOpenPurchaseForm',
            GroupIcon: MdAssignment,
            navItems: [
                { to: '/securePurchaseForm', name: 'secure purchase form', exact: false, Icon: MdWeb, id: 'Secure purchase form' },
                { to: '/purchaseCumReceiptForm', name: 'purchase cum receipt form', exact: false, Icon: MdWeb, id: 'Purchase cum receipt form' },
            ]
        }
    ]

    const rentFormGroup = [
        {
            group: 'Rent Form',
            stateName: 'isOpenRentForm',
            GroupIcon: MdEmail,
            navItems: [
                { to: '/secureRentForm', name: 'secure rent form', exact: false, Icon: MdWeb, id: 'Secure rent form' },
                { to: '/rentCumReceiptForm', name: 'rent cum receipt form', exact: false, Icon: MdWeb, id: 'Rent cum receipt form' },
            ]
        }
    ]

    // const developerSalesGroup = [
    //     {
    //         group: 'Developer Sales',
    //         stateName: 'isOpenDeveloperSales',
    //         GroupIcon: MdArrowDropDownCircle,
    //         navItems: [
    //             { to: '/developerSalesForm', name: 'developer sales form', exact: false, Icon: MdWeb, id: 'Developer sales form' },
    //         ]
    //     }
    // ]

    // const claimSubmissionGroup = [
    //     {
    //         group: 'Claim Submission',
    //         stateName: 'isOpenClaimSubmission',
    //         GroupIcon: MdArrowDropDownCircle,
    //         navItems: [
    //             { to: '/claims/claimslisting', name: 'claim submission form', exact: false, Icon: MdWeb, id: 'Claim submission form' },
    //         ]
    //     }
    // ]

    const officialReceiptGroup = [
        {
            group: 'Official Receipt',
            stateName: 'isOpenOfficialReceipt',
            GroupIcon: FaReceipt,
            navItems: [
                { to: '/receiptRequest/receiptRequestListing', name: 'official receipt request', exact: false, Icon: MdWeb, id: 'Official receipt request' },
                { to: '/receiptRequestHistory', name: 'official receipt request history', exact: false, Icon: MdWeb, id: 'Official receipt request history' },
                { to: '/receipt/receiptListing', name: 'official receipt', exact: false, Icon: MdWeb, id: 'Official receipt' },
            ]
        }
    ]

    const taxInvoiceGroup = [
        {
            group: 'Tax Invoice',
            stateName: 'isOpenTaxInvoice',
            GroupIcon: MdBook,
            navItems: [
                { to: '/invoiceRequest/invoiceRequestListing', name: 'tax invoice request', exact: false, Icon: MdWeb, id: 'Tax invoice request' },
                { to: '/invoiceRequestHistory', name: 'tax invoice request history', exact: false, Icon: MdWeb, id: 'Tax invoice request history' },
                { to: '/invoice/invoiceListing', name: 'tax invoice', exact: false, Icon: MdWeb, id: 'Tax invoice' },
            ]
        }
    ]

    const nextsixPropertyGroup = [
        {
            group: 'Nextsix Property',
            stateName: 'isOpenNextsixProperty',
            GroupIcon: MdHouse,
            navItems: [
                { to: '', name: 'TRR agent tool', exact: false, Icon: MdWeb, id: 'TRR agent tool' }
            ]
        }
    ]

    const myStoreGroup = [
        {
            group: 'My Store',
            stateName: 'isOpenMyStore',
            GroupIcon: HiShoppingCart,
            navItems: [
                { to: '/store/orderListing', name: 'store order listing', exact: false, Icon: MdWeb, id: 'Store Order Listing' },
            ]
        }
    ]

    const settingsGroup = [
        {
            group: 'Settings',
            stateName: 'isOpenSettings',
            GroupIcon: IoMdSettings,
            navItems: [
                { to: '/changePassword', name: 'change password', exact: false, Icon: MdWeb, id: 'Change Password' },
            ]
        }
    ]

    const Divider = () => (
        <div className='divider' style={{ borderBottom: "1px solid rgba(0,0,0,0.12)" }}></div>
    )

    const redirectToNextsixAgent = async () => {
        const res = await userbiz.createNextsixAgentLink(loggedInAgent._id);
        window.location.assign(res.authenticatedLink)
    }

    const toggle = () => {
        dispatch(toggleSidebar(false));
    }

    return (
        <>
            <div className={sidebarControl ? "side-drawer open" : "side-drawer"} ref={boxRef}>
                <div className="side-drawer-header">
                    <img className="side-drawer-logo" src={trrWebLogo} alt="" />
                    <div className="side-drawer-userInfo">
                        <div className="userInfo-label">Welcome: <span className="userInfo-userName">{loggedInAgent.UserName}</span></div>
                        <div className="userInfo-label">Branch: {loggedInAgent.UserBranchName}</div>
                        <div className="userInfo-label">User Module: Agent</div>
                    </div>
                    <MdClose className="side-drawer-header-close" size="20" onClick={toggle} />
                </div>
                <div className="side-drawer-body">
                    {myFolderGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    <a className="side-drawer-main-single" href="/memoListing">
                        <div className="side-drawer-navLink-single"><MdAnnouncement className="side-drawer-group-icon" />Memo Listing</div>
                    </a>
                    <Divider />
                    <a className="side-drawer-main-single" href="/letterListing">
                        <div className="side-drawer-navLink-single"><MdMail className="side-drawer-group-icon" />Company Letter</div>
                    </a>
                    <Divider />
                    {employmentApplicationGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {purchaseFormGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {rentFormGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    <a className="side-drawer-main-single" href="/developerSalesForm">
                        <div className="side-drawer-navLink-single">< MdDescription className="side-drawer-group-icon" />Developer Sales Form</div>
                    </a>
                    <Divider />
                    <a className="side-drawer-main-single" href="/claims/claimsListing">
                        <div className="side-drawer-navLink-single">< MdLocationCity className="side-drawer-group-icon" />Claim Submission Form</div>
                    </a>
                    <Divider />
                    {officialReceiptGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {taxInvoiceGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {nextsixPropertyGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ name }, i) => (
                                            <span key={i} className="side-drawer-navLink" onClick={redirectToNextsixAgent}>{name}</span>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {myStoreGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                        <a className="side-drawer-navLink" href={`http://buy.iproforma.com/home.html?agent=${loggedInAgent._id}`}>
                                            Shop
                                        </a>
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    {settingsGroup.map(({ group, stateName, GroupIcon, navItems }, i) => (
                        <Fragment key={i}>
                            <div onClick={handleCollapse(stateName)}>
                                <div className="side-drawer-main-group">
                                    <span className="side-drawer-group-title"><GroupIcon className="side-drawer-group-icon" />{group}</span>
                                    <MdKeyboardArrowDown size="20" style={{
                                        padding: 0,
                                        transform: isOpen[stateName]
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }} />
                                </div>
                                <Collapse isOpen={isOpen[stateName]}>
                                    <Nav vertical>
                                        {navItems.length > 0 && navItems.map(({ to, name }, i) => (
                                            <a key={i} className="side-drawer-navLink" href={to}>{name}</a>
                                        ))}
                                    </Nav>
                                </Collapse>
                                <Divider />
                            </div>
                        </Fragment>
                    ))}
                    <div className="side-drawer-main-single" onClick={logout}>
                        <div className="side-drawer-navLink-single">< MdLockOutline className="side-drawer-group-icon" />Sign Out</div>
                    </div>
                    <Divider />
                </div>
            </div>
            <div className={sidebarControl ? "backdrop" : ""}></div>
        </>
    )
}

export default Sidebar